import { Heading as GrommetHeading } from 'grommet'
import styled from 'styled-components'

const StyledHeading = styled(GrommetHeading)`
  font-family: Roboto;
  color: ${props => (props.color ? props.color : 'black')};
`

export { StyledHeading }
